import React from 'react';
import styled, {keyframes} from 'styled-components';
import {fadeIn} from 'react-animations';
import ImageLoaderSpinner from './CircleLoader';

const fadeInAnimation = keyframes`${fadeIn}`;

const CenterBackImage = styled.div`
    background-image: url(${props => props.url});
    width: 90%;
    height: 90%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    position: relative;
    border-radius: 50%;
`;

const ImageBack = styled.div`
    animation: 1s ${fadeInAnimation};
    width: inherit;
    height: inherit;
    border-radius: 50%;
    background-color: ${p => p.transparent ? 'transparent' : (p.theme.properties.darkLogo ? p.theme.colors.primaryText : p.theme.colors.surfaceFront)};
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const ImageWrapper = styled.div.attrs({
    className: 'image__wrapper',
})`
    height: 25vh;
    width: 25vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
    position: relative;
`;

const Component = (props) => {
    let content;

    if (props.loading) {
        content = <ImageLoaderSpinner/>;
    } else {
        content = (<ImageBack {...props}>
            <CenterBackImage {...props}/>
        </ImageBack>);
    }

    return (<ImageWrapper>
        {content}
    </ImageWrapper>)
};


export default Component;
